"use strict";

/* ---------------------------------------
 * Globals & constants (kept minimal)
 * ------------------------------------- */
let lastScrollTop = 0;

const LOGO_DEFAULT  = "/assets/svg/logo.svg";
const LOGO_SCROLLED = "/assets/svg/logo-down.svg";
const SCROLLED_IDS  = ["#gallery-flex", "#default", "#attractions", "#contact-us", ".sitemap"];

const HOME_BODY        = document.getElementById("home");
const HEADER_EL        = document.getElementById("header");
const TOP_CONTENT_HOME = document.getElementById("top-content-home");
const FRAME_EL         = document.getElementById("frame");
const IMG_CONTAINER    = document.getElementById("image-container");
const INTRO_HOME       = document.getElementById("intro-content-home");

/* Polyfill: NodeList.forEach for old browsers */
if ("NodeList" in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (cb, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) cb.call(thisArg, this[i], i, this);
  };
}

/* Helper: safely get the <img> inside .header__logo */
function getHeaderLogoImg() {
  const logoWraps = document.getElementsByClassName("header__logo");
  if (!logoWraps || !logoWraps[0]) return null;
  const imgs = logoWraps[0].getElementsByTagName("img");
  return imgs && imgs[0] ? imgs[0] : null;
}

/* Helper: true if this page should always load in "scrolled" mode (white logo, colored bg) */
function shouldForceScrolledHeader() {
  if (!HEADER_EL) return false;

  for (let i = 0; i < SCROLLED_IDS.length; i++) {
    var list = document.querySelectorAll(SCROLLED_IDS[i]);
    if (list && list.length > 0) {
      return true;
    }
  }

  return false;
}

/* ---------------------------------------
 * Early header init (runs immediately)
 * This prevents the white->dark->white flicker on forced-scrolled pages.
 * ------------------------------------- */
(function initHeaderImmediate() {
  if (!HEADER_EL) return;

  if (shouldForceScrolledHeader()) {
    // lock header in scrolled mode right away
    HEADER_EL.classList.add("scroll");

    const img = getHeaderLogoImg();
    if (img && img.getAttribute("src") !== LOGO_SCROLLED) {
      img.setAttribute("src", LOGO_SCROLLED);
    }
  }
})();

/* ---------------------------------------
 * Utils
 * ------------------------------------- */

/** Smoothly scroll to an element by id, compensating header height. */
function animateTo(targetId) {
  const target = document.getElementById(targetId);
  if (!target) return;

  const header = HEADER_EL || document.getElementsByTagName("header")[0];
  if (!header) return;

  const from   = window.pageYOffset || window.scrollY || 0;
  const absTop = target.getBoundingClientRect().top + from;

  const isMobile = window.matchMedia("(max-width: 639px)").matches;

  let to;
  if (isMobile) {
    const headerOffset = header ? (header.clientHeight + header.offsetTop) : 0;
    to = absTop - (headerOffset - 150);
  } else {
    const r = header.getBoundingClientRect();
    to = absTop - ((r.height + r.top) * 2);
  }

  const duration = 1400;
  const start = performance.now();

  const easeInOutQuart = function (t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  };

  function step(ts) {
    const elapsed  = ts - start;
    const progress = Math.min(elapsed / duration, 1);
    const y        = easeInOutQuart(progress) * (to - from) + from;
    window.scrollTo(0, y);
    if (elapsed < duration) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

/** Add animation classes to all elements matching selector. */
function addAnimations(selector, behavior) {
  const list = document.querySelectorAll(selector);
  for (let i = 0; i < list.length; i++) {
    list[i].classList.add("animate-fade");
    if (behavior) list[i].classList.add(behavior);
  }
}

/** Header behavior on scroll: toggle style + swap logo (only when not forced). */
function handleHeaderOnScroll() {
  if (!HEADER_EL) return;

  const y = document.documentElement.scrollTop || window.pageYOffset || 0;
  const isScrolled = y >= 80;

  HEADER_EL.classList.toggle("scroll", isScrolled);

  const img = getHeaderLogoImg();
  if (img) {
    const desired = isScrolled ? LOGO_SCROLLED : LOGO_DEFAULT;
    if (img.getAttribute("src") !== desired) {
      img.setAttribute("src", desired);
    }
  }

  lastScrollTop = y > 0 ? y : 0;
}

/* ---------------------------------------
 * Contrast helpers (background-aware text)
 * ------------------------------------- */

function parseColorToRGB(color) {
  if (!color) return null;
  if (color === "transparent") return { r: 0, g: 0, b: 0, a: 0 };

  if (color.indexOf("rgb") === 0) {
    const nums = (color.match(/[\d.]+/g) || []).map(Number);
    return { r: nums[0] || 0, g: nums[1] || 0, b: nums[2] || 0, a: nums.length > 3 && !isNaN(nums[3]) ? nums[3] : 1 };
  }

  if (color.charAt(0) === "#") {
    let hex = color.slice(1);
    if (hex.length === 3 || hex.length === 4) hex = hex.split("").map(function (c) { return c + c; }).join("");
    const int = parseInt(hex, 16);
    if (hex.length === 8) return { r: (int >> 24) & 255, g: (int >> 16) & 255, b: (int >> 8) & 255, a: (int & 255) / 255 };
    return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255, a: 1 };
  }
  return null;
}

function relLuminance(rgb) {
  function ch(c) { c = c / 255; return c <= 0.03928 ? (c / 12.92) : Math.pow((c + 0.055) / 1.055, 2.4); }
  const R = ch(rgb.r), G = ch(rgb.g), B = ch(rgb.b);
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

function contrastRatio(l1, l2) {
  const L1 = l1 > l2 ? l1 : l2;
  const L2 = l1 > l2 ? l2 : l1;
  return (L1 + 0.05) / (L2 + 0.05);
}

function pickTextByLuminance(bg) {
  const Lbg = relLuminance(bg);
  const Lw  = relLuminance({ r: 255, g: 255, b: 255 });
  const Ld  = relLuminance({ r: 55,  g: 58,  b: 54  }); // #373A36
  return contrastRatio(Lw, Lbg) >= contrastRatio(Ld, Lbg) ? "#fff" : "#373A36";
}

function getEffectiveBgColor(el) {
  let node = el;
  while (node && node.nodeType === 1) {
    const c = parseColorToRGB(getComputedStyle(node).backgroundColor);
    if (c && (typeof c.a === "undefined" || c.a > 0)) return c;
    node = node.parentElement;
  }
  const bodyC = parseColorToRGB(getComputedStyle(document.body).backgroundColor);
  return bodyC || { r: 255, g: 255, b: 255, a: 1 };
}

function extractBgURL(bgImage) {
  if (!bgImage || bgImage === "none") return null;
  const m = bgImage.match(/url\((['"]?)(.*?)\1\)/);
  return m ? m[2] : null;
}

function resolveDrawSize(sizeStr, contW, contH) {
  if (!sizeStr || sizeStr === "auto" || sizeStr === "contain" || sizeStr === "cover") {
    return { w: contW, h: contH };
  }
  const parts = String(sizeStr).trim().split(/\s+/);
  const sx = parts[0];
  const sy = parts[1] || "auto";

  function toPx(val, base, fallback) {
    if (val === "auto") return fallback;
    if (val.indexOf("%") > 0)  return (parseFloat(val) / 100) * base;
    if (val.indexOf("px") > 0) return parseFloat(val);
    return fallback;
  }

  const w = toPx(sx, contW, contW);
  const h = sy === "auto" ? contH : toPx(sy, contH, contH);
  return { w: w, h: h };
}

function parsePositionXY(cs, contW, contH, drawW, drawH) {
  const posX = cs.backgroundPositionX || "0%";
  const posY = cs.backgroundPositionY || "0%";

  function tokenToOffset(token, base, draw) {
    const t = (token || "").trim();
    if (t === "left" || t === "top" || t === "0%" || t === "0px") return 0;
    if (t === "center" || t === "50%") return (base - draw) / 2;
    if (t === "right" || t === "bottom" || t === "100%") return base - draw;
    if (t.indexOf("%") > 0) return (parseFloat(t) / 100) * (base - draw);
    if (t.indexOf("px") > 0) return parseFloat(t);
    return (base - draw) / 2;
  }

  return {
    x: tokenToOffset(posX, contW, drawW),
    y: tokenToOffset(posY, contH, drawH)
  };
}

function pointInsidePaintedArea(x, y, contW, contH, drawW, drawH, offX, offY, repeat) {
  let rx = x - offX, ry = y - offY;

  if (repeat === "repeat" || repeat === "repeat-x") {
    rx = ((rx % drawW) + drawW) % drawW;
  }
  if (repeat === "repeat" || repeat === "repeat-y") {
    ry = ((ry % drawH) + drawH) % drawH;
  }
  return rx >= 0 && ry >= 0 && rx <= drawW && ry <= drawH;
}

function findJsBackground(el) {
  let cur = el;
  while (cur && cur.nodeType === 1) {
    if (cur.classList && cur.classList.contains("js-background")) return cur;
    cur = cur.parentElement;
  }
  return null;
}

function applyContrast(el) {
  const holder = findJsBackground(el);
  const rect   = el.getBoundingClientRect();
  const cx     = rect.left + rect.width / 2;
  const cy     = rect.top  + rect.height / 2;

  if (!holder) {
    el.style.color = pickTextByLuminance(getEffectiveBgColor(el));
    return;
  }

  const cs  = getComputedStyle(holder);
  const url = extractBgURL(cs.backgroundImage);

  if (!url || url === "none") {
    el.style.color = pickTextByLuminance(getEffectiveBgColor(el));
    return;
  }

  const holderRect = holder.getBoundingClientRect();
  const xRel = cx - holderRect.left;
  const yRel = cy - holderRect.top;

  const draw   = resolveDrawSize(cs.backgroundSize, holderRect.width, holderRect.height);
  const pos    = parsePositionXY(cs, holderRect.width, holderRect.height, draw.w, draw.h);
  const repeat = cs.backgroundRepeat || "no-repeat";

  const inside = pointInsidePaintedArea(
    xRel, yRel, holderRect.width, holderRect.height, draw.w, draw.h, pos.x, pos.y, repeat
  );

  if (inside) {
    const tone = holder.getAttribute("data-bg-tone") || "dark";
    el.style.color = tone === "light" ? "#373A36" : "#fff";
  } else {
    el.style.color = pickTextByLuminance(getEffectiveBgColor(el));
  }
}

let _ticking = false;
function onViewChange() {
  if (_ticking) return;
  _ticking = true;
  requestAnimationFrame(function () {
    _ticking = false;
    const items = document.querySelectorAll(".js-text-contrast");
    for (let i = 0; i < items.length; i++) applyContrast(items[i]);
  });
}

/* ---------------------------------------
 * Main init (DOMContentLoaded)
 * ------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (HEADER_EL) {
    document.documentElement.style.setProperty( "--header-height",  (HEADER_EL.clientHeight + HEADER_EL.offsetTop) + "px");
  }
  
  const FORCE_DOWN = shouldForceScrolledHeader();

  if (HEADER_EL) {
    if (FORCE_DOWN) {
      // (keep header locked in scrolled mode)
    } else {
      window.addEventListener("scroll", handleHeaderOnScroll, { passive: true });
      handleHeaderOnScroll();
    }
  }

  document.querySelectorAll("p").forEach(function (p) {
    if (!p.textContent.trim()) p.remove();
  });

  const signupIds = ["email-signup_email_address", "email-signup_FNAME", "email-signup_LNAME"];
  for (let i = 0; i < signupIds.length; i++) {
    const el = document.getElementById(signupIds[i]);
    if (!el) continue;
    el.addEventListener("focus", function (e) {
      const parent = e.target.parentElement;
      if (parent) parent.classList.add("moved");
    });
  }

  const labelFields = document.querySelectorAll(".form-module__field input:not([type=checkbox]):not([type=radio]), .form-module__field select, .form-module__field textarea");
  labelFields.forEach(function (field) {
    field.addEventListener("focus", function () {
      const parent = field.parentElement;
      if (parent) parent.classList.add("moved");
    });
  });

  if (window.location.hash) {
    const id = window.location.hash.substring(1);
    animateTo(id);
  }

  const anchors = document.querySelectorAll('[href*="#"]:not([data-lbx])');
  anchors.forEach(function (a) {
    const targetId = a.hash ? a.hash.substring(1) : "";
    if (!targetId || !document.getElementById(targetId)) return;
    a.addEventListener("click", function (e) {
      e.preventDefault();
      animateTo(targetId);
    });
  });

  onViewChange();
  window.addEventListener("resize", onViewChange, { passive: true });
  window.addEventListener("scroll", onViewChange, { passive: true });
  const mo = new MutationObserver(onViewChange);
  mo.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["class", "style"] });

(function layoutHeaderNav() {
    const nav = document.querySelector(".privary-navigation__list");
    const logoLink = document.querySelector(".header__logo");

    if (!nav || !logoLink) return;

    const items = Array.from(nav.querySelectorAll("li.privary-navigation__item"));

    const firstGroup  = items.slice(0, 4);
    const secondGroup = items.slice(4);

    const leftWrap  = document.createElement("li");
    const rightWrap = document.createElement("li");
    const logoWrap  = document.createElement("li");

    leftWrap.className  = "nav-left";
    rightWrap.className = "nav-right";
    logoWrap.className  = "nav-logo";

    const leftUL  = document.createElement("ul");
    const rightUL = document.createElement("ul");

    firstGroup.forEach(item => leftUL.appendChild(item));
    secondGroup.forEach(item => rightUL.appendChild(item));

    leftWrap.appendChild(leftUL);
    rightWrap.appendChild(rightUL);
    logoWrap.appendChild(logoLink);

    nav.innerHTML = "";
    nav.appendChild(leftWrap);
    nav.appendChild(logoWrap);
    nav.appendChild(rightWrap);
})();


  setTimeout(function () {
    const els = [HOME_BODY, HEADER_EL, TOP_CONTENT_HOME, FRAME_EL, IMG_CONTAINER];
    for (let i = 0; i < els.length; i++) if (els[i]) els[i].classList.add("animated");
  }, 2000);

  (function observeOnce(target, opts) {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    if (!el || !("IntersectionObserver" in window)) return;

    const className = (opts && opts.className) || "animated";
    const offset    = (opts && typeof opts.offset === "number") ? opts.offset : 40;

    const obs = new IntersectionObserver(function (entries) {
      for (let i = 0; i < entries.length; i++) {
        const ent = entries[i];
        if (ent.isIntersecting || ent.intersectionRatio > 0) {
          el.classList.add(className);
          obs.unobserve(el);
          obs.disconnect();
          break;
        }
      }
    }, { root: null, threshold: 0, rootMargin: "0px 0px -" + offset + "px 0px" });

    obs.observe(el);
  })(INTRO_HOME, { className: "animated", offset: 40 });

  (function fadeInAllContent() {
    const selectors = [
      ".js-text-contrast",
      "#gallery-flex #content"
    ];

    const seen = new Set();
    const nodes = [];
    for (let s = 0; s < selectors.length; s++) {
      const found = document.querySelectorAll(selectors[s]);
      for (let i = 0; i < found.length; i++) {
        const el = found[i];
        if (!seen.has(el)) {
          seen.add(el);
          nodes.push(el);
        }
      }
    }
    if (nodes.length === 0) return;

    for (let j = 0; j < nodes.length; j++) {
      nodes[j].style.transition = "opacity 0.5s ease";
      // nodes[j].style.opacity = "0"; // enable if you want hard fade-from-0
    }

    setTimeout(function () {
      for (let k = 0; k < nodes.length; k++) {
        nodes[k].style.opacity = "1";
      }
    }, 500);
  })();

  function isMobile() { return window.innerWidth <= 640; }

  function convertSubmenuToSelect() {
    const submenu = document.querySelector(".sub-menu__hold .sub-menu ul");
    if (!submenu) return;

    const select = document.createElement("select");
    select.setAttribute("aria-label", "Section Navigation");

    const liItems = submenu.querySelectorAll("li");
    liItems.forEach(function (li) {
      const link = li.querySelector("a");
      if (!link) return;
      const opt = document.createElement("option");
      opt.value = link.href;
      opt.textContent = (link.textContent || "").trim();
      if (link.classList.contains("active")) opt.selected = true;
      select.appendChild(opt);
    });

    select.addEventListener("change", function (e) {
      const url = e.target.value;
      if (url) window.location.href = url;
    });

    submenu.parentNode.replaceChild(select, submenu);
  }

  if (isMobile()) convertSubmenuToSelect();

  const introDefault = document.querySelector("#intro-content-default");
  if (introDefault) {
    if (introDefault.querySelector(".sub-menu__hold .sub-menu")) {
      introDefault.classList.add("with-submenu");
    } else {
      introDefault.classList.remove("with-submenu");
    }
  }

  (function toggleFixedSubmenuOnScroll() {
    const header = HEADER_EL;
    const hold   = document.querySelector(".sub-menu__hold");
    if (!header || !hold) return;

    const initialTop = hold.getBoundingClientRect().top + window.scrollY;
    window.addEventListener("scroll", function () {
      const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
      if (headerBottom >= initialTop) {
        hold.style.position = "fixed";
        hold.style.top = "90px";
      } else if (window.scrollY < initialTop) {
        hold.style.position = "absolute";
        hold.style.top = "0px";
      }
    }, { passive: true });
  })();

  	// BURGUER MENU MOBILE ----------------------------------------------------------------

		const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
		const burgerMenuContainer = document.querySelector("#js-menuContainer")
		const closeMenu = document.querySelector(".js-burger-close");
		
		//Open Menu

		if(burgerMenuBtn){
			burgerMenuBtn.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenuContainer.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		}
		
		if(closeMenu){
			closeMenu.addEventListener('click', () => {
				burgerMenuContainer.classList.remove("open");
				document.body.classList.remove("no-scroll");
			});
		}

    // SHOW SUBMENU FUNCTION: 

    const submenuToShow = (linksSelector, linkSubmenu) => {
    let navLinks = document.querySelectorAll(linksSelector); 
    let submenu_active = document.querySelectorAll(linkSubmenu); 

    // Toggle submenu on click
    navLinks.forEach(link => {
      const parent = link.parentNode;
      let submenu = parent.querySelector('.submenu');
      link.addEventListener('click', (e) => {
        document.querySelectorAll('.submenu.active').forEach(activeSubmenu => {
          activeSubmenu.classList.remove('active');
        });
        document.querySelectorAll(`${linksSelector}.active`).forEach(activeLink => {
          activeLink.classList.remove('active');
        });
        link.classList.toggle('active');
        if (submenu) submenu.classList.toggle('active');
      });
    });

    submenu_active.forEach(sub => {
      if (sub.classList.contains('active')) {
        let selectedLink;
        if (window.screen.width > 640) {
          selectedLink = sub.parentNode.parentNode.parentNode.children[0];
        } else {
          selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
        }

        if (selectedLink) {
          selectedLink.classList.add('selected');

          if (window.screen.width <= 640) {
            const liParent = selectedLink.closest('li');
            if (liParent) liParent.classList.add('selected');
          }
        }
      }
    });
  };

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}


		const navItems = document.querySelectorAll('.privary-navigation__item');
		const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');
		
		function addNoSubmenuClass() {
			navItems.forEach(item => {
				
				const submenu = item.querySelector('.privary-navigation__submenu');
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}
		
		function addNoSubmenuMobileClass() {
			navItemsMob.forEach(item => {
				
				const submenu = item.querySelector('.sub-sub-menu');
				
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});

		}
		if(window.screen.width > 768) {
			addNoSubmenuClass();
		}else{
			addNoSubmenuMobileClass()
		}

    // LIGHTBOX LENIS PREVENT 

    const Lightbox = new LBX('.js-lbx', {
      beforeShow: function () {
        this.$modal.setAttribute('data-lenis-prevent', '')
      }
    });

    document.addEventListener("click", function (e) {
      const link = e.target.closest("a.btn");
      if (!link) return;

      const href = link.getAttribute("href");
      if (!href) return;

      if (
        href.startsWith("tel:") ||
        href.startsWith("mailto:") ||
        href.startsWith("javascript:")
      ) { 
        return; 
      }

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch (err) {
        return;
      }

      if (!url.hash) return;

      const samePage =
        url.origin === window.location.origin &&
        url.pathname.replace(/\/+$/, "") === window.location.pathname.replace(/\/+$/, "");

      if (!samePage) {
        return;
      }

      const hash = url.hash;
      const id   = hash.substring(1);
      if (!id) return;

      e.preventDefault();
      animateTo(id);
      history.pushState(null, "", hash);
    });


});
